const aaa = [
	{
		path: "pandianlist",
		component: () => import("@/views/pandian/pandian/list.vue"),
		meta:{title:'库存盘点'},
	},	{
		path: "pandianAdd",
		component: () => import("@/views/pandian/pandian/add.vue"),
		meta:{title:'库存'},
	},
	
]
export default aaa;